module.exports = __webpack_public_path__ + "c7f96a73720a46764697d8ec9fcd8b37.svg";